import React, { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import { toast } from "sonner";
import { submitContact } from "../api";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please complete the required fields");
      return;
    }
    try {
      await submitContact(form);
      toast.success("Message sent", { description: "Our team will respond within 24 hours." });
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong", { description: "Please try again in a moment." });
    }
  };

  const info = [
    { icon: Mail, label: "Email", value: "admin@kanama.org" },
    { icon: MapPin, label: "Address", value: "KANAMA NATURALS, 54 State Street, Ste 804 #15721, Albany, New York 12207, US" }
  ];

  return (
    <div>
      <section className="py-24 border-b border-[#2c2822] text-center">
        <div className="max-w-[720px] mx-auto px-6">
          <p className="text-[#c9a24b] text-sm tracking-[0.3em] uppercase mb-5">Let's Chat</p>
          <h1 className="font-display text-[46px] md:text-[64px] text-[#f4efe4] leading-tight">
            We'd Love to Hear From You
          </h1>
          <p className="text-[#a29a8c] mt-5">
            Questions about our rituals, ingredients or your order? Reach out —
            we're here to help.
          </p>
        </div>
      </section>

      <section className="max-w-[1280px] mx-auto px-6 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16">
        {/* Info */}
        <div>
          <h2 className="font-display text-3xl text-[#f4efe4] mb-8">Get in touch</h2>
          <div className="space-y-6">
            {info.map((item, i) => (
              <div key={i} className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full border border-[#c9a24b]/40 flex items-center justify-center shrink-0">
                  <item.icon size={20} className="text-[#c9a24b]" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="text-[#6b6459] text-xs tracking-[0.15em] uppercase">{item.label}</p>
                  <p className="text-[#f4efe4] mt-1">{item.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="gold-hairline my-10" />
          <p className="text-[#a29a8c] text-sm leading-relaxed">
            Prefer social? Find us on Instagram, Facebook and Twitter for rituals,
            tips and community stories.
          </p>
        </div>

        {/* Form */}
        <div className="bg-[#141210] border border-[#2c2822] rounded-lg p-8 md:p-10">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-[#a29a8c] text-xs tracking-[0.15em] uppercase mb-2">Name *</label>
                <input name="name" value={form.name} onChange={handleChange} className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md px-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="Your name" />
              </div>
              <div>
                <label className="block text-[#a29a8c] text-xs tracking-[0.15em] uppercase mb-2">Email *</label>
                <input name="email" type="email" value={form.email} onChange={handleChange} className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md px-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="you@email.com" />
              </div>
            </div>
            <div>
              <label className="block text-[#a29a8c] text-xs tracking-[0.15em] uppercase mb-2">Subject</label>
              <input name="subject" value={form.subject} onChange={handleChange} className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md px-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="How can we help?" />
            </div>
            <div>
              <label className="block text-[#a29a8c] text-xs tracking-[0.15em] uppercase mb-2">Message *</label>
              <textarea name="message" value={form.message} onChange={handleChange} rows={5} className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md px-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors resize-none" placeholder="Tell us more..." />
            </div>
            <button type="submit" className="btn-gold w-full py-4 rounded-full text-sm tracking-[0.2em] uppercase font-medium inline-flex items-center justify-center gap-2">
              Send Message <Send size={16} />
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
